import { EntrepreneurAnnounce9FormContainer } from "../../../containers/SupportSystem/SupportForm/EntrepreneurAnnounce9FormContainer";
export function EntrepreneurAnnounce9FormPage() {
    return (
        <EntrepreneurAnnounce9FormContainer />
    );

}